import { render, staticRenderFns } from "./BasicSpinner.vue?vue&type=template&id=df7a406c&"
import script from "./BasicSpinner.vue?vue&type=script&lang=js&"
export * from "./BasicSpinner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports